import { render, staticRenderFns } from "./FixedOverlay.vue?vue&type=template&id=626096a8&scoped=true&"
var script = {}
import style0 from "./FixedOverlay.vue?vue&type=style&index=0&id=626096a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626096a8",
  null
  
)

export default component.exports